import React from 'react';
import { Flex, Box, Lead } from 'rebass';
import Link from 'gatsby-link';
import styled from 'styled-components';
import Logo from '../app/components/logo';
import theme from '../app/themes';

const TagLine = styled(Lead)`
  line-height: 1;
  font-family: ${theme.sansSerif};
  font-weight: 300;
`;

const Trade = styled(Box)`
  display: inline-block;
  padding-left: 2px;
  margin-right: -15px;
`;

const LogoLink = styled(Link)`
  color: ${theme.colors.brand};
  transition: color cubic-bezier(.4, 0, .2, 1) 100ms;

  &:hover {
    color: #1fba59;
  }
`;

export default () => (
  <Flex
    align="center"
    column
  >
    <Box
      mb={3}
      width={['65%', '45%', '70%']}
    >
      <LogoLink to="/">
        <Logo.Icon />
      </LogoLink>
    </Box>
    <Box
      color="black"
      mb={3}
      width={['70%', '50%', '75%']}
      to="/"
    >
      <Logo.Text />
    </Box>
    <Box mt={1} mb={4}>
      <TagLine
        is="h2"
        f={[5, 6, 3]}
        mx={-2}
        mt={[2, 3, 0]}
        center
      >
        Results Driven<br />Web Development
        <Trade
          f={[6, 7, 5]}
        >
          &trade;
        </Trade>
      </TagLine>
    </Box>
  </Flex>
);



// WEBPACK FOOTER //
// ./src/Branding/index.js